import React from 'react';

import KeyChip from '@dashboard/components/KeyChip';
import { Box, Skeleton, Stack, Typography } from '@mui/material';

import { useCurrentContactId, useCurrentContactQuery } from './hooks';

export default function ContactShowHeader() {
  const { data } = useCurrentContactQuery();
  const id = useCurrentContactId();

  const loading = data === undefined;
  const emailAddress = loading ? <Skeleton width={320} /> : data.Contact.emailAddress;
  const name = loading ? <Skeleton width={150} /> : data.Contact.name || '--';

  return (
    <Stack spacing={0.5}>
      <Stack spacing={1} alignItems="baseline" direction="row">
        <Typography variant="h4">{emailAddress}</Typography>
        <Box sx={{ display: { xs: 'none', md: 'block' } }}>
          <KeyChip label={id} tooltipTitle="Copy contact id to clipboard" />
        </Box>
      </Stack>
      <Typography variant="body2" color="text.secondary">
        {name}
      </Typography>
    </Stack>
  );
}
